module.exports = __webpack_public_path__ + "static/img/loader.50af38a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprites/loader.png
// module id = 722
// module chunks = 2